import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton, CHECKOUT_URL } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-38">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center bg-white/90 border-brand-purple/30 shadow-lg relative overflow-hidden" data-id="element-39">
        <div className="absolute top-0 left-0 w-24 h-24 bg-brand-purple/10 rounded-br-full -z-10" data-id="element-40"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-brand-gold/10 rounded-tl-full -z-10" data-id="element-41"></div>

        <h2 className="text-2xl md:text-4xl font-display font-bold mb-8 text-brand-purpleDark leading-tight" data-id="element-42">
          Hay dos versiones de vos en este momento.
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text mb-10 max-w-2xl mx-auto" data-id="element-43">
          <p data-id="element-44">
            Una que cierra esta página y la próxima sesión sigue sin saber
            exactamente qué serie prescribir, cómo estructurar la sesión y cómo
            proteger su propio campo energético.
          </p>
          <p className="font-medium text-brand-purple" data-id="element-45">
            Y otra que decide que hoy es el día en que su práctica de Chi Kung
            cambia para siempre.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-brand-goldDark" data-id="element-46">
            La pregunta no es si podés pagarlo.
            <br data-id="element-47" />
            La pregunta es cuántas sesiones más vas a trabajar sin un sistema
            clínico que te respalde.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-48">
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-2 border-brand-purple bg-white/95 text-center flex flex-col relative shadow-[0_10px_30px_rgba(45,95,63,0.18)]" data-id="element-49">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-purple text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap" data-id="element-50">
              ⭐ MÁS ELEGIDO
            </div>
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-purple mb-1 mt-2" data-id="element-51">
              🏆 MEGA PACK CHI KUNG™
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-purple mb-3" data-id="element-52">
              $24.990 ARS
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-53">
              3 Tomos + 6 Bonus · Más de 190 páginas. El sistema integral de
              sesiones pre-diseñadas y blindaje para el terapeuta profesional.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href={CHECKOUT_URL} variant="purple" data-id="element-54">
              🏆 → QUIERO MI MEGA PACK $24.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-55">
          <div className="flex items-center" data-id="element-56">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-57" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-58">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-59" /> Acceso en 5
            minutos
          </div>
          <div className="flex items-center" data-id="element-60">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-61" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-62">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-63" /> Mercado
            Pago | Tarjeta
          </div>
        </div>

        <div className="text-sm text-brand-text bg-brand-surfaceLight/60 p-5 md:p-6 rounded-2xl border border-brand-purple/20 space-y-3 text-left md:text-center" data-id="element-64">
          <p data-id="element-65">
            <strong className="text-brand-purpleDark" data-id="element-66">P.D.:</strong> Si tenés
            dudas, escribinos a{' '}
            <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-goldDark hover:underline font-medium" data-id="element-67">
              soportelumenakasha@gmail.com
            </a>{' '}
            o a{' '}
            <a href="https://instagram.com/lumen.akasha" className="text-brand-goldDark hover:underline font-medium" data-id="element-68">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="italic text-brand-goldDark" data-id="element-69">
            El precio de lanzamiento sube pronto. El mejor momento para tener tu
            sistema clínico de Chi Kung es ahora.
          </p>
        </div>
      </div>
    </Section>;
};